/**
 * Fixed paper-fiber overlay. The single cheapest thing that stops #F3EEE3
 * reading as flat digital cream (docs/DESIGN-V9.md §2).
 *
 * v8's film grain became v9's paper tooth: the turbulence is desaturated
 * (a `saturate 0` feColorMatrix strips the RGB speckle cast, leaving a
 * neutral luminance texture) and composited with `multiply` so it darkens
 * the ground like real fiber inclusions rather than dusting it with grey.
 *
 * Static, not animated, so it needs no reduced-motion fallback — it is
 * texture, not movement. Rendered once, composited by the GPU, and
 * `pointer-events: none` so it never intercepts a click.
 */
export function Grain() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-90 opacity-[0.05] mix-blend-multiply">
      <svg className="h-full w-full">
        <filter id="lokta-fiber">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.55"
            numOctaves="2"
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#lokta-fiber)" />
      </svg>
    </div>
  );
}
